import { createRouter, createWebHistory } from 'vue-router'
import i18n from '@/locales'

import HomePage from '@/components/system/HomePage.vue'

import TransferServer from '@/components/network/TransferServer.vue'
import DistributionServer from '@/components/network/DistributionServer.vue'
import OfficialClient from '@/components/network/OfficialClient.vue'
import OfficialServer from '@/components/network/OfficialServer.vue'

import ServerMapping from '@/components/network/ServerMapping.vue'

import P2PClient from '@/components/network/P2PClient.vue'
import P2PSetting from '@/components/network/P2PSetting.vue'

import ProxyPage from '@/components/proxy/ProxyPage.vue'
import ReverseProxy from '@/components/network/ReverseProxy.vue'

import UserLogin from '@/components/user/UserLogin.vue'
import UserManagement from '@/components/user/UserManagement.vue'
import FileManagement from '@/components/file/FileManagement.vue'
import FileList from '@/components/file/FileList.vue'
import NetworkFileServices from '@/components/file/NetworkFileServices.vue'
import CollectList from '@/components/file/CollectPage.vue'
import ShareLinkList from '@/components/file/ShareLink.vue'

import MountMgmt from '@/components/mount/MountMgmt.vue'

import DDNSSetting from '@/components/dns/DDNSSetting.vue'
import AliyunDDNS from '@/components/dns/AliyunDDns.vue'
import PubyunDDNS from '@/components/dns/PubyunDDns.vue'
import NameyunDDNS from '@/components/dns/NameyunDDns.vue'
import TencentCloudDDNS from '@/components/dns/TencentCloudDDns.vue'
import CloudflareDDNS from '@/components/dns/CloudflareDDns.vue'

import AcmeMgmt from '@/components/acme/AcmePage.vue'

import FileSync from '@/components/filesync/FileSync.vue'

import DeviceCenter from '@/components/device/DeviceCenter.vue'

import ModuleMgmt from '@/components/module/ModuleMgmt.vue'

import SettingPage from '@/components/system/SettingPage.vue'
import About from '@/components/system/About.vue'

const routes = [
    {
        path: '/',
        redirect: '/sys-home'
    },
    {
        path: '/sys-home',
        name: 'sysHome',
        component: HomePage,
        meta: { titleKey: 'nav.sysHome' }
    },
    {
        path: '/transfer-server',
        name: 'transferServer',
        component: TransferServer,
        meta: { titleKey: 'nav.transferServer' }
    },
    {
        path: '/distribution-server',
        name: 'distributionServer',
        component: DistributionServer,
        meta: { titleKey: 'nav.distributionServer' }
    },
    {
        path: '/official-client',
        name: 'officialClient',
        component: OfficialClient,
        meta: { titleKey: 'nav.officialClient' }
    },
    {
        path: '/official-server',
        name: 'officialServer',
        component: OfficialServer,
        meta: { titleKey: 'nav.officialServer' }
    },
    {
        path: '/server-mapping',
        name: 'serverMapping',
        component: ServerMapping,
        meta: { titleKey: 'nav.serverMapping' }
    },
    {
        path: '/p2p-setting',
        name: 'p2pSetting',
        component: P2PSetting,
        meta: { titleKey: 'nav.p2pSetting' }
    },
    {
        path: '/p2p-client',
        name: 'p2pClient',
        component: P2PClient,
        meta: { titleKey: 'nav.p2pClient' }
    },
    {
        path: '/user-login/:id(.*)*',
        name: 'userLogin',
        component: UserLogin,
        meta: { titleKey: 'nav.userLogin' }
    },
    {
        path: '/user-mgmt',
        name: 'userMgmt',
        component: UserManagement,
        meta: { requiresAuth: true, titleKey: 'nav.userManagement' }
    },
    {
        path: '/file-setting',
        name: 'fileSetting',
        component: FileManagement,
        meta: { requiresAuth: true, titleKey: 'nav.fileConfig' }
    },
    {
        path: '/file-list',
        name: 'fileList',
        component: FileList,
        meta: { requiresAuth: true, titleKey: 'nav.fileList' }
    },
    {
        path: '/collect-list',
        name: 'collectList',
        component: CollectList,
        meta: { requiresAuth: true, titleKey: 'nav.favorites' }
    },
    {
        path: '/shareLink-list',
        name: 'shareLinkList',
        component: ShareLinkList,
        meta: { requiresAuth: true, titleKey: 'nav.shareFolder' }
    },
    {
        path: '/network-file-services',
        name: 'networkFileServices',
        component: NetworkFileServices,
        meta: { requiresAuth: true, titleKey: 'nav.networkFileService' }
    },
    {
        path: '/mount-mgmt',
        name: 'mountMgmt',
        component: MountMgmt,
        meta: { requiresAuth: true, titleKey: 'nav.mountMgmt' }
    },
    {
        path: '/ddns-setting',
        name: 'ddnsSetting',
        component: DDNSSetting,
        meta: { requiresAuth: true, titleKey: 'nav.ddnsSetting' }
    },
    {
        path: '/aliyun-ddns',
        name: 'aliyunDdns',
        component: AliyunDDNS,
        meta: { requiresAuth: true, titleKey: 'nav.aliyunDdns' }
    },
    {
        path: '/pubyun-ddns',
        name: 'pubyunDdns',
        component: PubyunDDNS,
        meta: { requiresAuth: true, titleKey: 'nav.pubyunDdns' }
    },
    {
        path: '/nameyun-ddns',
        name: 'nameyunDdns',
        component: NameyunDDNS,
        meta: { requiresAuth: true, titleKey: 'nav.namecomDdns' }
    },
    {
        path: '/tencentcloud-ddns',
        name: 'tencentcloudDdns',
        component: TencentCloudDDNS,
        meta: { requiresAuth: true, titleKey: 'nav.tencentcloudDdns' }
    },
    {
        path: '/cloudflare-ddns',
        name: 'cloudflareDdns',
        component: CloudflareDDNS,
        meta: { requiresAuth: true, titleKey: 'nav.cloudflareDdns' }
    },
    {
        path: '/acme-mgmt',
        name: 'acmeMgmt',
        component: AcmeMgmt,
        meta: { requiresAuth: true, titleKey: 'nav.acmeManagement' }
    },
    {
        path: '/proxy-mgmt',
        name: 'proxyMgmt',
        component: ProxyPage,
        meta: { requiresAuth: true, titleKey: 'nav.forwardProxy' }
    },
    {
        path: '/reverse-proxy',
        name: 'reverseProxy',
        component: ReverseProxy,
        meta: { requiresAuth: true, titleKey: 'nav.reverseProxy' }
    },
    {
        path: '/file-sync-mgmt',
        name: 'fileSyncMgmt',
        component: FileSync,
        meta: { requiresAuth: true, titleKey: 'nav.fileSync' }
    },
    {
        path: '/device-center',
        name: 'deviceCenter',
        component: DeviceCenter,
        meta: { requiresAuth: true, titleKey: 'nav.deviceCenter' }
    },
    {
        path: '/module-mgmt',
        name: 'moduleMgmt',
        component: ModuleMgmt,
        meta: { requiresAuth: true, titleKey: 'nav.moduleManagement' }
    },
    {
        path: '/sys-setting',
        name: 'sysSetting',
        component: SettingPage,
        meta: { requiresAuth: true, titleKey: 'nav.systemSettings' }
    },
    {
        path: '/sys-about',
        name: 'sysAbout',
        component: About,
        meta: { titleKey: 'nav.sysAbout' }
    },
    {
        path: '/error',
        name: 'ErrorPage',
        component: () => import('@/components/common/ErrPage.vue'),
        meta: { titleKey: 'common.error' }
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: {
            path: '/error',
            query: {
                message: '404页面不存在'
            }
        }
    }
    // // 可以添加一个404页面
    // {
    //     path: '/:pathMatch(.*)*',
    //     name: 'NotFound',
    //     component: () => import('@/components/common/NotFound.vue')
    // }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

// 可选：设置页面标题
router.beforeEach((to, from, next) => {
    if (to.meta.titleKey) {
        document.title = i18n.global.t(to.meta.titleKey) || to.meta.titleKey
    } else {
        document.title = to.meta.title || 'tfcenter'
    }
    next()
})

export default router
